import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from 'react-router-dom';
import React from 'react';
import { isUUID } from 'shared/utils/uuid';
import { toBase16 } from 'shared/utils/b58';
export const useLocationId = () => {
  const $ = _c(10);
  const [searchParams, setSearchParams] = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("lid");
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const locationId_ = t0;
  let locationId = locationId_;
  if (locationId && !isUUID(locationId)) {
    if (locationId == "undefined") {
      locationId = null;
    } else {
      if (locationId.length > 1 && locationId.length < 32) {
        let t1;
        if ($[2] !== locationId) {
          t1 = toBase16(locationId);
          $[2] = locationId;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        locationId = t1;
      } else {
        if (locationId.length !== 32) {
          locationId = null;
        }
      }
    }
  }
  const locationId_0 = locationId;
  let t1;
  if ($[4] !== locationId_0 || $[5] !== setSearchParams) {
    t1 = lid => {
      if (locationId_0 == lid) {
        return;
      }
      setSearchParams(prev => ({
        ...Object.fromEntries(prev.entries()),
        lid: lid || ""
      }), {
        replace: true
      });
    };
    $[4] = locationId_0;
    $[5] = setSearchParams;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const setLocation = t1;
  let t2;
  if ($[7] !== locationId_0 || $[8] !== setLocation) {
    t2 = [locationId_0, setLocation];
    $[7] = locationId_0;
    $[8] = setLocation;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
export const useBookableIds = () => {
  const $ = _c(9);
  const [searchParams, setSearchParams] = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("bids") || "";
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const bids = t0;
  let t1;
  if ($[2] !== bids) {
    t1 = bids.split(",").map(_temp);
    $[2] = bids;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const bookableIds = t1;
  let t2;
  if ($[4] !== setSearchParams) {
    t2 = bookableIds_0 => {
      setSearchParams(prev => ({
        ...Object.fromEntries(prev.entries()),
        bids: bookableIds_0.join(",")
      }), {
        replace: true
      });
    };
    $[4] = setSearchParams;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const setBookableIds = t2;
  let t3;
  if ($[6] !== bookableIds || $[7] !== setBookableIds) {
    t3 = [bookableIds, setBookableIds];
    $[6] = bookableIds;
    $[7] = setBookableIds;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export const useDuration = () => {
  const $ = _c(7);
  const [searchParams, setSearchParams] = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("duration");
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const duration = t0;
  let t1;
  if ($[2] !== setSearchParams) {
    t1 = duration_0 => {
      setSearchParams(prev => ({
        ...Object.fromEntries(prev.entries()),
        duration: duration_0 || ""
      }), {
        replace: true
      });
    };
    $[2] = setSearchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const setDuration = t1;
  const t2 = Number(duration) || null;
  let t3;
  if ($[4] !== setDuration || $[5] !== t2) {
    t3 = [t2, setDuration];
    $[4] = setDuration;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
function _temp(id) {
  return id || null;
}